export default function dynamicMask(maskit, masks, tokens) {
  const sortMasks = masks.sort((a, b) => a.length - b.length);
  return function(value, mask, masked = true) {
    var i = 0;
    while (i < sortMasks.length) {
      var currentMask = sortMasks[i];
      i++;
      var nextMask = sortMasks[i];
      if (
        !(
          nextMask &&
          maskit(value, nextMask, true, tokens).length > currentMask.length
        )
      ) {
        return maskit(value, currentMask, masked, tokens);
      }
    }
    return ""; // empty masks
  };
}



// WEBPACK FOOTER //
// ./src/components/utils/vue-the-mask/dynamic-mask.js